import { ApiService } from './api.service'

export const ADMService = {
    createRateExchange,
    deleteRateExchange,
    fetchRateExchange,
    fetchRateExchangeList,
    fetchRateExchangeListAll,
    postRateExchangeFromExcel,
    taxGet,
    taxGetOrCreate,
    taxGetList,
    taxEdit,
    taxDelete,
    taxScheduleGet,
    taxScheduleGetOrCreate,
    taxScheduleGetList,
    taxScheduleEdit,
    taxScheduleDelete,
    taxScheduleDetailCreate,
    taxScheduleDetailGetList,
    taxScheduleDetailDelete,
    paymentMethodGet,
    paymentMethodGetOrCreate,
    paymentMethodGetList,
    paymentMethodEdit,
    paymentMethodDelete,
    
}

function createRateExchange (xch_date, xch_rate) {
    return ApiService.post('/admin/rate-exchange/', { xch_rate, xch_date })
}

function deleteRateExchange (id) {
    return ApiService.delete(`/admin/rate-exchange/${id}`)
}
/* Administration */

function fetchRateExchange(date1) {
    //   /**
    //    * @returns object
    //    **/
    return ApiService.get(`/admin/rate-exchange/date/${date1}`);
}

function fetchRateExchangeList(date1, date2) {
    //   /**
    //    * @returns array
    //    **/
    return ApiService.get(`/admin/rate-exchange?xch_date1=${date1}&xch_date2=${date2}`);
}

function fetchRateExchangeListAll(limit, page) {
    //   /**
    //    * @returns array
    //    **/
    return ApiService.get(`/admin/rate-exchange/list-all?limit=${limit}&page=${page}`);
}

function postRateExchangeFromExcel(data) {
    //   /**
    //    * @returns object
    //    **/
    return ApiService.post(`/admin/rate-exchange/excel`, data);
}


function taxGet(taxCode){
    return ApiService.get(`/admin/tax?tax_code=${taxCode}`)
}
function taxGetOrCreate(taxCode){
    return ApiService.post(`/admin/tax`, {taxCode})
}
function taxGetList(query="", page = 0){
    return ApiService.get(`/admin/tax/list?query=${query}&page=${page}`)
}
function taxEdit(data){
    return ApiService.put(`/admin/tax`, data)
}
function taxDelete(id){
    return ApiService.delete(`/admin/tax/${id}`)
}

function taxScheduleGet(taxScheduleCode){
    return ApiService.get(`/admin/tax-schedule/${taxScheduleCode}`)
}
function taxScheduleGetOrCreate(taxScheduleCode){
    return ApiService.post(`/admin/tax-schedule`, {taxScheduleCode})
}
function taxScheduleGetList(query="", page = 0){
    return ApiService.get(`/admin/tax-schedule?query=${query}&page=${page}`)
}
function taxScheduleEdit(data){
    return ApiService.put(`/admin/tax-schedule`, data)
}
function taxScheduleDelete(id){
    return ApiService.delete(`/admin/tax-schedule/${id}`)
}

function taxScheduleDetailCreate(data){
    return ApiService.post(`/admin/tax-schedule/detail`, data)
}
function taxScheduleDetailGetList(id, query = '', page = 0){
    return ApiService.get(`/admin/tax-schedule/detail/${id}?query=${query}&page=${page}`)
}
function taxScheduleDetailDelete(id){
    return ApiService.delete(`/admin/tax-schedule/detail/${id}`)
}

function paymentMethodGet(paymentMethodCode){
    return ApiService.get(`/admin/payment-method/${paymentMethodCode}`)
}
function paymentMethodGetOrCreate(paymentMethodCode){
    return ApiService.post(`/admin/payment-method`, {paymentMethodCode})
}
function paymentMethodGetList(query="", page = 0, limit =30){
    return ApiService.get(`/admin/payment-methods?query=${query}&page=${page}&limit=${limit}`)
}
function paymentMethodEdit(data){
    return ApiService.put(`/admin/payment-method`, data)
}
function paymentMethodDelete(id){
    return ApiService.delete(`/admin/payment-method/${id}`)
}






// WEBPACK FOOTER //
// ./src/services/admin.service.js